module.exports = __webpack_public_path__ + "static/media/license.4cacffe1.md";